import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getFamilyName } from "src/modules/auth/duck/selectors";
import PairingSuccess from "src/modules/pairing/scenes/Success";
import { useNavigate } from "react-router-dom";
import { wasInDashboardBefore } from "src/duck/selectors";
import resolveText from "./resolveText";
import { getRequest } from "../../duck/selectors";

export default function ResponderPairingSuccess({
  flow,
  closeWizard,
  dispatch,
  renderNavigationButtons,
  location,
  ...rest
}) {
  const { t } = useTranslation();
  const { pairingType, deviceName } = useSelector(getRequest) || {};
  const familyName = useSelector(getFamilyName);
  const requesterFamilyName = useSelector(getRequest)?.familyName;
  const shouldGoToDashboad = !useSelector(wasInDashboardBefore);
  const navigate = useNavigate();
  function handleOnDone() {
    shouldGoToDashboad && navigate("/dashboard");
    closeWizard();
  }
  const text = resolveText({
    t,
    deviceName,
    familyName,
    pairingType,
    requesterFamilyName,
    didLogIn: flow.state.didLogIn,
    didSignUp: flow.state.didSignUp
  });

  return (
    <PairingSuccess
      text={text}
      onDone={handleOnDone}
      onClose={closeWizard}
      {...rest}
    />
  );
}
